import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QaLocatorsModule } from '@metromarkets/sdk';
import { KebabCaseModule } from '~shared/pipes';
import { TranslateModule } from '@ngx-translate/core';
import { MmFlexLayoutModule } from '@metromarkets/components';
import { ProductDiscountLabelComponent } from '~shared/modules/product-discount-label/product-discount-label.component';

@NgModule({
  declarations: [
    ProductDiscountLabelComponent
  ],
  imports: [
    CommonModule,
    MmFlexLayoutModule,
    QaLocatorsModule,
    KebabCaseModule,
    TranslateModule,
  ],
  exports: [
    ProductDiscountLabelComponent,
  ]
})
export class ProductDiscountLabelModule {
}
